export default {
	"Adlam": false,
	"Ahom": false,
	"Anatolian_Hieroglyphs": false,
	"Arabic": false,
	"Armenian": false,
	"Avestan": false,
	"Balinese": false,
	"Bamum": false,
	"Bassa_Vah": false,
	"Batak": false,
	"Bengali": false,
	"Bhaiksuki": false,
	"Bopomofo": false,
	"Brahmi": false,
	"Braille": false,
	"Buginese": false,
	"Buhid": false,
	"Canadian_Aboriginal": false,
	"Carian": false,
	"Caucasian_Albanian": false,
	"Chakma": false,
	"Cham": false,
	"Cherokee": false,
	"Common": false,
	"Coptic": false,
	"Cuneiform": false,
	"Cypriot": false,
	"Cyrillic": false,
	"Deseret": false,
	"Devanagari": false,
	"Dogra": false,
	"Duployan": false,
	"Egyptian_Hieroglyphs": false,
	"Elbasan": false,
	"Ethiopic": false,
	"Georgian": false,
	"Glagolitic": false,
	"Gothic": false,
	"Grantha": false,
	"Greek": false,
	"Gujarati": false,
	"Gunjala_Gondi": false,
	"Gurmukhi": false,
	"Han": false,
	"Hangul": false,
	"Hanifi_Rohingya": false,
	"Hanunoo": false,
	"Hatran": false,
	"Hebrew": false,
	"Hiragana": false,
	"Imperial_Aramaic": false,
	"Inherited": false,
	"Inscriptional_Pahlavi": false,
	"Inscriptional_Parthian": false,
	"Javanese": false,
	"Kaithi": false,
	"Kannada": false,
	"Katakana": false,
	"Kayah_Li": false,
	"Kharoshthi": false,
	"Khmer": false,
	"Khojki": false,
	"Khudawadi": false,
	"Lao": false,
	"Latin": false,
	"Lepcha": false,
	"Limbu": false,
	"Linear_A": false,
	"Linear_B": false,
	"Lisu": false,
	"Lycian": false,
	"Lydian": false,
	"Mahajani": false,
	"Makasar": false,
	"Malayalam": false,
	"Mandaic": false,
	"Manichaean": false,
	"Marchen": false,
	"Masaram_Gondi": false,
	"Medefaidrin": false,
	"Meetei_Mayek": false,
	"Mende_Kikakui": false,
	"Meroitic_Cursive": false,
	"Meroitic_Hieroglyphs": false,
	"Miao": false,
	"Modi": false,
	"Mongolian": false,
	"Mro": false,
	"Multani": false,
	"Myanmar": false,
	"Nabataean": false,
	"New_Tai_Lue": false,
	"Newa": false,
	"Nko": false,
	"Nushu": false,
	"Ogham": false,
	"Ol_Chiki": false,
	"Old_Hungarian": false,
	"Old_Italic": false,
	"Old_North_Arabian": false,
	"Old_Permic": false,
	"Old_Persian": false,
	"Old_Sogdian": false,
	"Old_South_Arabian": false,
	"Old_Turkic": false,
	"Oriya": false,
	"Osage": false,
	"Osmanya": false,
	"Pahawh_Hmong": false,
	"Palmyrene": false,
	"Pau_Cin_Hau": false,
	"Phags_Pa": false,
	"Phoenician": false,
	"Psalter_Pahlavi": false,
	"Rejang": false,
	"Runic": false,
	"Samaritan": false,
	"Saurashtra": false,
	"Sharada": false,
	"Shavian": false,
	"Siddham": false,
	"SignWriting": false,
	"Sinhala": false,
	"Sogdian": false,
	"Sora_Sompeng": false,
	"Soyombo": false,
	"Sundanese": false,
	"Syloti_Nagri": false,
	"Syriac": false,
	"Tagalog": false,
	"Tagbanwa": false,
	"Tai_Le": false,
	"Tai_Tham": false,
	"Tai_Viet": false,
	"Takri": false,
	"Tamil": false,
	"Tangut": false,
	"Telugu": false,
	"Thaana": false,
	"Thai": false,
	"Tibetan": false,
	"Tifinagh": false,
	"Tirhuta": false,
	"Ugaritic": false,
	"Vai": false,
	"Warang_Citi": false,
	"Yi": false,
	"Zanabazar_Square": false
};

export const NAME_ALIAS = {};